export const getDefaultButtonSx = () => ({
  borderRadius: "50px",
  width: "200px",
  height: "32px",
  fontSize: "12px",
  color: "#373737",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "1.8px 5px 1.8px 15px",
  cursor: "pointer",
  border: "1px solid #ccc",
  bgcolor: "#eeeeee",
});

export const getDefaultTextFieldSx = () => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    width: "auto",
    height: "35px",
    bgcolor: "#eeeeee",
  },
});

export const getDefaultMenuSx = (theme) => ({
  mt: 1.5,
  ml: "8px",
  borderRadius: "10px",
  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
  bgcolor: "#ffffff",
  width: "286px",
  padding: "0 16px",
  border: `1px solid ${theme.palette.divider}`,
  position: "relative",
  overflow: "visible",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-12px",
    right: "18px",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "12px solid #ffffff",
    filter: "drop-shadow(-2px -1px 2px rgba(0, 0, 0, 0.05)) drop-shadow(2px -1px 2px rgba(0, 0, 0, 0.05))",
    zIndex: 1,
  },
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "5px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#707ca8",
    borderRadius: "5px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#d5d5d5",
    borderRadius: "5px",
  },
  "&::-webkit-scrollbar-button": {
    display: "none",
  }
});

export const getDefaultMenuItemSx = () => ({
  height: "30px",
  fontSize: "14px",
  color: "#707cab",
  padding: "8px 16px",
  borderRadius: 1,
  "&:hover": {
    color: "#8695CB",
    bgcolor: "#dbe0fc",
    borderRadius: 1,
  },
});

export const getDefaultTopologySx = () => ({
  mt: 1.5,
  ml: -2,
  color: "#373737",
  fontSize: "13px",
  fontWeight: "bold",
});

export const getDefaultCheckboxSx = () => ({
  "&:hover": {
    backgroundColor: 'transparent !important'
  },
});

export const getDefaultTabIndicatorProps = () => ({
  style: {
    height: '5px',
    borderRadius: '1em',
    backgroundColor: "rgb(112, 124, 168)"
  }
});

export const getDefaultTabSx = () => ({
  "& button": {
    "&:hover": {
      backgroundColor: "transparent",
      color: '#373737'
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "16px",
    color: '#aaaaaa',
    "&:hover": {
      color: '#aaaaaa'
    },
    "&.Mui-selected": {
      fontWeight: 600,
      color: "rgb(112, 124, 168)",
    },
  },
});